function copyThat(that) {
    var inp = document.createElement('input');
    document.body.appendChild(inp)
    inp.value = that.textContent
    inp.select();
    document.execCommand('copy', false);
    inp.remove();

    $(that).attr("title", "Zkopírováno!").tooltip("_fixTitle").tooltip("show").attr("title", "Klikni pro zkopírování").tooltip("_fixTitle");

}